<template>
  <v-data-table
    v-if="vehiclesStore.vehiclesInUserInventory"
    :headers="tableHeaders"
    :items="vehiclesStore.vehiclesInUserInventory || []"
    :items-per-page="itemsPerPage"
    :loading="vehiclesStore.vehicleDataLoading"
    fixed-header
    hover
    :items-per-page-options="[5, 10, 20]"
    :items-length="vehiclesStore.vehiclesInUserInventory?.length"
    :server-items-length="vehiclesStore.vehiclesInUserInventory?.length"
    must-sort
    >
    <template v-slot:item="{ item }">
      <tr class="cursor-pointer">
        <td>
          {{ (item as any).value.split('--')[0] + ' ' + (item as any).value.split('--')[1] }}
        </td>
        <td>
          {{ (item as any).count }}
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useVehiclesStore } from '@/stores/vehicles'

const itemsPerPage = 10

const vehiclesStore = useVehiclesStore()
onMounted(() => {
  vehiclesStore.getVehiclesData()
})

const tableHeaders = [
  {
    title: 'Make/Model',
    key: 'make',
    align: 'start' as const,
    value: 'value',
  },
  {
    title: 'Count',
    key: 'count',
    align: 'start' as const,
    value: 'count',
  },
]
</script>
